export default "__VITE_ASSET__xYsMwGSp__"